<template>
  <div id="app"  >
    <HeaderM v-if="HeaderMShow" :class="{show:HeaderMShow}" />
    <div class="nav" :class="{navShow:showNav2}">
      <div class="close" @click="showNav2=false" v-if="showNav2">
        <i class="iconfont icon-guanbi"></i>
      </div>
      <ul v-if="showNav2">
        <li   style="animation-delay: 200ms;" class="animated fadeInUp"><a title="首页" href="./index.html" target="_self">首页</a></li>
        <li   style="animation-delay: 260ms;" class="animated fadeInUp"><a title="关于我们" href="./about.html" target="_self">关于我们</a></li>
        <li  style="animation-delay: 320ms;" class="animated fadeInUp"><a title="产品中心" href="./pro.html" target="_self">产品中心</a></li>
        <li  style="animation-delay: 380ms;" class="animated fadeInUp"><a title="案例中心" href="./case.html" target="_self">案例中心</a></li>
        <li  style="animation-delay: 440ms;" class="animated fadeInUp"><a title="服务中心" href="./service.html" target="_self">服务中心</a></li>
<!--        <li  style="animation-delay: 500ms;" class="animated fadeInUp"><a title="News" href="./news.html" target="_self">News</a></li>-->
        <li  style="animation-delay: 560ms;" class="animated fadeInUp"><a title="联系我们" href="./contact.html" target="_self">联系我们</a></li>
      </ul>
    </div>
    <div id="page" :class="{menushow:HeaderMShow,showPage:showNav2}">
      <first-Component page="home" @menushow="menushow" @showNav="showNav" v-if="!showNav2"></first-Component>

      <div id="scroller-wrapper" data-scrollbar >
        <home-Component :showNav="showNav2"></home-Component>
      </div>
    </div>


  </div>
</template>

<script>
  import  {WOW} from 'wowjs'
  import Scrollbar from 'smooth-scrollbar';
  import firstComponent from '@/components/first.vue'
  import HeaderM from '@/components/Header-m.vue';
  import homeComponent from '@/views/index.vue'
  import { setTimeout } from 'timers';
  export default {
    name: 'home',
    data(){
      return{
        loader:true,
        loading:false,
        noShow:{},
        wow:'',
        scrollbar:'',
        showNav2:'',
        HeaderMShow: false
      }
    },
    // watch:{
    //   '$route':'init'
    // },
    components:{firstComponent,homeComponent,HeaderM},
    mounted() {
      this.wow=new WOW();
      this.init()
      // this.$nextTick(() => {
      //   setTimeout(()=>{
      //     this.loading=true
      //     this.loadingAddNum(0, 10);
      //   },1000)
      // });
      // this.$router.beforeEach((to, from, next) => {
      //   Scrollbar.destroyAll()
      //   next()
      // })
    },
    methods:{
      menushow(HeaderMShow){
        this.HeaderMShow=HeaderMShow
      },
      showNav(n){
        this.showNav2=n
      },
      loadingAddNum(num, step) {
        setTimeout(() => {
          const processbar = document.getElementById('processbar');
          const loadingratio = document.getElementById('loadingratio');
          processbar.style.width = num + '%';
          loadingratio.innerText = num + '%';

          if (num < 99) {
            let startNum = Math.ceil(num + step);
            if (startNum > 100) {
              startNum = 100;
            }
            this.loadingAddNum(startNum, step);
          } else {
            setTimeout(()=>{
              this.loader=false
              this.wow.init()
            },1000)

          }
        }, 200);
      },
      init(){
        this.$nextTick(()=>{
          this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
          this.wow.init()
          this.noShow={display:'block'}
          let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
          scrollbar.scrollTo(0,0)
          window.pageYOffset=this.scrollbar.scrollTop
          this.scrollbar.addListener(() => {
            this.wow.scrollHandler()
            window.pageYOffset=this.scrollbar.scrollTop
            if(window.pageYOffset>0){
              this.noShow={display:'none'}
            }
          });
        })
      }
    }
  }
</script>
<style>
  body{
    margin: 0;
    padding: 0;
  }
  ul,li,p,a{
    margin: 0;
    padding: 0;
    text-decoration: none;
    color:black;
  }
  .el-input{
    width:45% !important;
    margin-left:5%;
    margin-top: 30px;
  }
  .el-textarea{
    width:95%;
    margin-left: 5%;
    margin-top: 30px;
  }
  input:focus {
    border-color: #DCDFE6 !important;
    outline: 0;
  }
  textarea:focus{
    border-color: #DCDFE6 !important;
    outline: 0;
    resize: none !important;
  }
#app {
  font-family: "Source Sans Pro", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width:100%;
  overflow: hidden;
  perspective: 2000px;
  transition: all 600ms;
}

  #page{
    transition: 600ms;
    position: relative;
    z-index: 102;
  }
  .showPage{
    transform:rotateY(30deg);
    transform-origin: 0 100% 0;
  }
  #page.menushow{
    transform: translate(0,60vh);
  }
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #D8C3A3!important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
</style>
<style lang="scss">
  .nav{
    color: #37383a;
    vertical-align: baseline;
    position: fixed;
    z-index: 99;
    height: 100vh;
    transition: all 700ms cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 25%;
    transform: translateX( 280px );
    right: -25%;
    top:0;
    .close{
      position: absolute;
      right:30%;
      top:2%;
      i{
        font-size: 25px;
        color:white;
        cursor: pointer;
        transition: all 600ms;
        transform: rotate(90deg);
      }
    }
    ul{
      position: absolute;
      top: 15%;
      overflow: hidden;
      height: 70%;
      margin: 0;
      padding: 0;
      list-style-type: none;
      left: 50px;
      width: calc( 100% - 100px );
      visibility: visible;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex-pack: start;
      justify-content: flex-start;
      -ms-flex-align: center;
      align-items: center;
      font-family: "Roboto",-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif;
      font-weight: 300;
      font-style: normal;
      text-transform: none;
      font-size: 31px;
      line-height: 57px;
      letter-spacing: 0;
      color: #a2a2a2;
      li{
        -webkit-font-smoothing: antialiased;
        visibility: visible;
        font-family: "Roboto",-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif;
        font-weight: 300;
        font-style: normal;
        text-transform: none;
        line-height: 57px;
        letter-spacing: 0;
        color: #a2a2a2;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        font-size: 100%;
        vertical-align: baseline;
        background: transparent;
        margin-bottom: 10px;
        flex: 0 0 auto;
        display: block;
        position: relative;
        text-align: center;
        width: 100%;
        animation-delay: 200ms;
        a{
          position: relative;
          z-index: 1;
          color: #ffffff;
          cursor: pointer;
          display: inline-block;
          line-height: inherit;
          font-size: 16px;
          &::before{
            position: absolute;
            overflow: hidden;
            white-space: nowrap;
            max-width: 0;
            transition: max-width .5s cubic-bezier(0.2,.7,.3,1) 80ms;
            background-color: transparent;
            content: attr(title);
            color: #ffffff;
            border-bottom: 1px solid #ffffff;
          }
          &:hover{
            color: inherit;
            &::before{
              max-width: 100%;
            }
          }
        }
      }
      li:nth-child(1){
        a{
          color: inherit;
          &::before{
            max-width: 100%;
          }
        }
      }
    }
    .icons{
      width:100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 50px auto;
      a{
        cursor: pointer;
        color:#A3A3A3;
        transition: all 600ms;
        margin: 0 20px;
        display: inline-block;
        i{
          font-size: 30px;
        }
        &:hover{
          color:#F7C56B;
        }
      }
    }
  }
  .navShow{
    transform: translatex(0px);
    right: 0;
    background-color: black;
  }
</style>
